// src/components/Loading.jsx

import React from "react";

const messages = {
  pt: "Carregando...",
  en: "Loading...",
  es: "Cargando...",
};

const Loading = ({ locale = "pt" }) => {
  const text = messages[locale] || messages.pt;

  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>{text}</p>
    </div>
  );
};

export default Loading;
